import "./App.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./assets/css/libraries/bootstrap.rtl.min.css";
import "./assets/css/libraries/font-icon.css";
import "./assets/css/style.css";
import Login from "./pages/login";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import WarrantyForm from "./pages/WarrantyForm";
import Orders from "./pages/orders";
import Profile from "./pages/profile";
import { UserProvider } from "./context/UserProvider";

function App() {
  return (
    <Router>
      <UserProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/" element={<WarrantyForm />} />
        </Routes>
        <ToastContainer />
      </UserProvider>
    </Router>
  );
}

export default App;
